import { resourceClient } from '@/Core/Services/ResourceClientService'
import { notificationService } from '@/Core/Services/NotificationService'
import { t } from 'i18next'

import type { IDeleteActionHandlerTaskParams } from './DeleteActionHandlerTask.types'

// Map для відстеження активних запитів видалення (захист від подвійного виклику)
const deletingItemsMap = new Map<string, boolean>()

export const DeleteActionHandlerTask = ({ item, crudContext }: IDeleteActionHandlerTaskParams): void => {

    const primaryFieldCode = crudContext.resource.primaryFieldCode || 'uuid'
    const id = item[primaryFieldCode]
    const deletingKey = `${crudContext.resource.key}:${id}`
    
    // Перевіряємо чи не виконується вже запит на видалення цього елемента
    if (deletingItemsMap.get(deletingKey)) {
        return
    }
    
    // Встановлюємо lock ВІДРАЗУ (синхронно, без delay)
    deletingItemsMap.set(deletingKey, true)

    const deletePromise = resourceClient.delete(
        crudContext.resource,
        {},
        {
            restUrlReplaceParams: { id },
        }
    )
    
    // Перевіряємо чи повернувся Promise
    if (!deletePromise) {
        deletingItemsMap.delete(deletingKey)
        notificationService.showError(
            t('Error', { ns: 'Core' }),
            t('Failed to delete record', { ns: 'Core' })
        )
        return
    }
    
    deletePromise
        .then(() => {
            // Оновлюємо таблицю ПЕРЕД видаленням прапорця (щоб уникнути race condition)
            if (crudContext.listContext?.actions?.load) {
                crudContext.listContext.actions.load(true) // forceRefresh = true
            }
            
                        // Видаляємо прапорець після успішного видалення
            deletingItemsMap.delete(deletingKey)
            
            // Викликаємо подію після видалення
            crudContext.eventManager?.emit('onAfterDeleteRequest', { id, item, crudContext })
            
            // Показуємо повідомлення про успіх
            notificationService.showSuccess(
                t('Success', { ns: 'Core' }),
                t('Record deleted successfully', { ns: 'Core' })
            )
        })
        .catch(async (error: any) => {
            // Видаляємо прапорець при помилці
            deletingItemsMap.delete(deletingKey)
            
            let response = error.response
            
            // Перевіряємо чи це помилка 404 (елемент вже видалено)
            if (error?.response?.status === 404) {
                // Все одно оновлюємо список
                if (crudContext.listContext?.actions?.load) {
                    crudContext.listContext.actions.load(true)
                }
                
                // НЕ показуємо notification - елемент все одно зникне зі списку
                return
            }
            
            try {
                response = await response.json()
            } catch (e) {
                // Ігноруємо помилку парсингу
            }

            notificationService.showError(
                t('Error', { ns: 'Core' }),
                response?.message || response?.['hydra:description'] || t('Failed to delete record', { ns: 'Core' })
            )
        })
}
